import {Component, Inject, Input, OnInit} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {MxField} from '../../services/mxField';
import {MxFormErrorMessageService} from '../../../../services/mx-form-error-message.service';
import {MX_TRANSLATE_SERVICE_TOKEN, MxTranslateService} from '../../../../../../shared/services/mx-translate.service';

@Component({
    selector: 'mx-check-box-field',
    standalone: false,
    templateUrl: './mx-check-box-field.component.html',
    styleUrls: ['./mx-check-box-field.component.scss']
})
export class MxCheckBoxFieldComponent extends MxField implements OnInit {

    @Input()
    unshielded: boolean = false;

    constructor(protected errorService: MxFormErrorMessageService,
                @Inject(MX_TRANSLATE_SERVICE_TOKEN) protected translateService: MxTranslateService) {
        super(errorService, translateService);
    }

    ngOnInit(): void {
        let componentControl: AbstractControl = this.form.controls[this.name];
        if (componentControl.value && typeof componentControl.value === 'string') {
            componentControl.setValue(componentControl.value.toLowerCase() === 'true');
        }
        if (this.readonly) {
            this.form.controls[this.name].disable();
        }
    }
}
